import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const Pencil: React.FC<SvgProps> = ({ color, ...props }) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    {...props}>
    <Path
      d="M13.0035 2.45C12.3035 1.70625 11.5597 0.9625 10.816 0.240625C10.6628 0.0875 10.4878 0 10.291 0C10.0941 0 9.89722 0.065625 9.76597 0.21875L1.5191 8.4C1.38785 8.53125 1.30035 8.68438 1.23472 8.8375L0.0315972 12.5125C-0.0340278 12.6875 0.00972223 12.8625 0.0972222 12.9938C0.206597 13.125 0.359722 13.2125 0.556597 13.2125H0.644097L4.38472 11.9656C4.55972 11.9 4.71285 11.8125 4.82222 11.6813L13.0253 3.5C13.1566 3.36875 13.2441 3.17187 13.2441 2.975C13.2441 2.77812 13.1566 2.60312 13.0035 2.45ZM4.12222 11.0031C4.10035 11.025 4.07847 11.025 4.0566 11.0469L1.23472 11.9875L2.17535 9.16563C2.17535 9.14375 2.19722 9.12188 2.2191 9.1L8.23472 3.10625L10.1378 5.00938L4.12222 11.0031ZM10.816 4.30938L8.91285 2.40625L10.2472 1.07187C10.8816 1.68437 11.516 2.34062 12.1285 2.975L10.816 4.30938Z"
      fill={color || '#FFF'}
    />
  </Svg>
);

export default Pencil;
